export default "__VITE_ASSET__Dm6POfHP__"